"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonFormErrorMessagesEnum = exports.BronsonFormValidationsEnum = exports.BronsonLanguages = void 0;
var BronsonLanguages;
(function (BronsonLanguages) {
    BronsonLanguages["ESP"] = "ESP";
    BronsonLanguages["ENG"] = "ENG";
})(BronsonLanguages = exports.BronsonLanguages || (exports.BronsonLanguages = {}));
var BronsonFormValidationsEnum;
(function (BronsonFormValidationsEnum) {
    BronsonFormValidationsEnum["isNumber"] = "isNumber";
    BronsonFormValidationsEnum["isEmail"] = "isEmail";
    BronsonFormValidationsEnum["isMultiEmail"] = "isMultiEmail";
    BronsonFormValidationsEnum["required"] = "required";
    BronsonFormValidationsEnum["isText"] = "isText";
    BronsonFormValidationsEnum["isAlphaNum"] = "isAlphaNum";
    BronsonFormValidationsEnum["isAlphaNumWithDash"] = "isAlphaNumWithDash";
    BronsonFormValidationsEnum["isAlphaNumWithDot"] = "isAlphaNumWithDot";
    BronsonFormValidationsEnum["isCurrency"] = "isCurrency";
    BronsonFormValidationsEnum["isOnlyDigits"] = "isOnlyDigits";
    BronsonFormValidationsEnum["hasMinLength"] = "hasMinLength";
    BronsonFormValidationsEnum["isTaxId"] = "isTaxId";
    BronsonFormValidationsEnum["isTaxIdWithHomoclave"] = "isTaxIdWithHomoclave";
    BronsonFormValidationsEnum["isTaxIdPF"] = "isTaxIdPF";
    BronsonFormValidationsEnum["isTaxIdPM"] = "isTaxIdPM";
    BronsonFormValidationsEnum["isPhone"] = "isPhone";
    BronsonFormValidationsEnum["startsWith"] = "startsWith";
    BronsonFormValidationsEnum["isUrl"] = "isUrl";
})(BronsonFormValidationsEnum = exports.BronsonFormValidationsEnum || (exports.BronsonFormValidationsEnum = {}));
exports.BronsonFormErrorMessagesEnum = {
    isText: { 'ESP': 'Por favor ingresa un valor alfabético válido', 'ENG': 'Please type a valid alphabetic value.' },
    isNumber: { 'ESP': 'Por favor ingresa un valor numérico válido', 'ENG': 'Please type a valid numeric value.' },
    isEmail: { 'ESP': 'Por favor ingresa un correo electrónico válido', 'ENG': 'Please type a valid email.' },
    required: { 'ESP': 'Por favor ingresa un valor', 'ENG': 'Please type a value.' },
    isAlphaNum: { 'ESP': 'Por favor ingresa un valor alfanúmerico válido', 'ENG': 'Please type a valid alphabetic value.' },
    isAlphaNumWithDash: { 'ESP': 'Por favor ingresa un valor alfanúmerico válido', 'ENG': 'Please type a valid alphanumeric value.' },
    isAlphaNumWithDot: { 'ESP': 'Por favor ingresa un valor alfanúmerico válido', 'ENG': 'Please type a valid alphanumeric value.' },
    isCurrency: { 'ESP': 'Por favor, ingresa solamente dos decimales', 'ENG': 'Please type only two decimals.' },
    isOnlyDigits: { 'ESP': 'Por favor, ingresa solamente dígitos (sin letras, ni caracteres especiales)', 'ENG': 'Please type only digits (no letters, no special characters).' },
    hasMinLength: { 'ESP': 'Por favor ingresa mínimo de {minLength} caracteres', 'ENG': 'Please type minimum {minLength} characters.' },
    isTaxId: { 'ESP': 'Por favor, ingresa un RFC válido', 'ENG': 'Please type a valid tax Id.' },
    isTaxIdWithHomoclave: { 'ESP': 'Por favor, ingresa un RFC válido', 'ENG': 'Please type a valid tax Id.' },
    isTaxIdPF: { 'ESP': 'Por favor, ingresa un RFC válido', 'ENG': 'Please type a valid tax Id.' },
    isTaxIdPM: { 'ESP': 'Por favor, ingresa un RFC válido', 'ENG': 'Please type a valid tax Id.' },
    isPhone: { 'ESP': 'Por favor ingresa un valor numérico válido', 'ENG': 'Please type a valid numeric value.' },
    startsWith: { 'ESP': 'Por favor ingresa un valor que empiece con {startsWith}', 'ENG': 'Please type a valid value starts with {startsWith}.' },
    isMultiEmail: { 'ESP': 'Por favor ingresa un correo electrónico válido, para varios sepárelos con punto y coma ";"', 'ENG': 'Please enter a valid email, for several separate them with semicolon ";"' },
    isUrl: { 'ESP': 'Por favor ingresa una URL válida', 'ENG': 'Please type a valid URL value.' }
};
